import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import type { ChildrenProps, ClassNameProps } from "../types";

/** Props Interface */
export interface ModalBodyProps
	extends ChildrenProps,
		ClassNameProps,
		VariantProps<typeof modalBody> {}

export function ModalBody({ children, className, variant, gap }: ModalBodyProps) {
	const classes = modalBody({ variant, gap });

	/** Render */
	return (
		<div
			className={clsx(
				"flex-grow-0 overflow-x-hidden overflow-y-scroll",
				"flex flex-col",
				classes,
				className,
			)}
		>
			{children}
		</div>
	);
}

const modalBody = cva([], {
	variants: {
		variant: {
			padding: ["modal-padding"],
			withoutPadding: [],
		},
		gap: {
			0: ["gap-0"],
			1: ["gap-1"],
			2: ["gap-2"],
			3: ["gap-3"],
			4: ["gap-4"],
			5: ["gap-5"],
			6: ["gap-6"],
			7: ["gap-7"],
			8: ["gap-8"],
			9: ["gap-9"],
			10: ["gap-10"],
		},
	},
	defaultVariants: {
		gap: 4,
		variant: "padding",
	},
});
